<template>
  <div class="show_all_content_wrapper">
    <!-- Start:: Main Section -->
    <main>
      <!--  =========== Start:: Filter Form =========== -->
      <div
        class="filter_content_wrapper"
        :class="{ active: filterFormIsActive }"
      >
        <button
          class="filter_toggler"
          @click="filterFormIsActive = !filterFormIsActive"
        >
          <i class="fal fa-times"></i>
        </button>
        <div class="filter_title_wrapper">
          <h5>{{ $t("TITLES.searchBy") }}</h5>
        </div>
        <div class="filter_form_wrapper">
          <form @submit.prevent="submitFilterForm">
            <div class="row justify-content-center align-items-center w-100">
              <!-- Start:: Order Type Input -->

              <!-- Start:: Order Number Input -->
              <base-input
                col="4"
                type="text"
                :placeholder="$t('PLACEHOLDERS.order_number')"
                v-model.trim="filterOptions.order_id"
              />
              <!-- End:: Order Number Input -->

              <!-- Start:: Provider Name Input -->
              <base-input
                col="4"
                type="text"
                :placeholder="$t('PLACEHOLDERS.provider_name')"
                v-model.trim="filterOptions.provider_name"
              />
              <!-- End:: Provider Name Input -->

              <!-- Start:: User Name Input -->
              <base-input
                col="4"
                type="text"
                :placeholder="$t('PLACEHOLDERS.user_name')"
                v-model.trim="filterOptions.user_name"
              />
              <!-- End:: User Name Input -->

              <!-- Start:: Start Date Input -->
              <base-picker-input
                col="4"
                type="date"
                :placeholder="$t('PLACEHOLDERS.startDate')"
                v-model.trim="filterOptions.created_at_from"
              />
              <!-- End:: Start Date Input -->

              <!-- Start:: End Date Input -->
              <base-picker-input
                col="4"
                type="date"
                :placeholder="$t('PLACEHOLDERS.endDate')"
                v-model.trim="filterOptions.created_at_to"
              />
              <!-- End:: End Date Input -->
            </div>

            <div class="btns_wrapper">
              <button class="submit_btn" :disabled="isWaitingRequest">
                <i class="fal fa-search"></i>
              </button>
              <button
                class="reset_btn"
                type="button"
                :disabled="isWaitingRequest"
                @click="resetFilter"
              >
                <i class="fal fa-redo"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <!--  =========== End:: Filter Form =========== -->

      <!--  =========== Start:: Table Title =========== -->
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("PLACEHOLDERS.FinancialOrders") }}</h5>
          <button
            v-if="!filterFormIsActive"
            class="filter_toggler"
            @click.stop="filterFormIsActive = !filterFormIsActive"
          >
            <i class="fal fa-search"></i>
          </button>
        </div>

        <div class="title_route_wrapper">
          <div class="excel" @click="downloadExcel">
            {{ $t("BUTTONS.downloadExcel") }}
          </div>

          <base-button
            class="mt-0 pdf_btn"
            styleType="solid_btn"
            :btnText="$t('BUTTONS.downloadPdf')"
            @fireClick="downloadPdf"
            :disabled="pdfDownloadBtnIsLoading"
          >
            <template v-slot:btn_icon>
              <i class="fal fa-file-pdf"></i>
            </template>
          </base-button>
        </div>
      </div>
      <!--  =========== End:: Table Title =========== -->

      <!--  =========== Start:: Data Table =========== -->
      <v-data-table
        class="thumb"
        :loading="loading"
        :loading-text="$t('TABLES.loadingData')"
        :search="searchValue"
        :headers="tableHeaders"
        :items="tableRows"
        item-class="ltr"
        :items-per-page="paginations.items_per_page"
        hide-default-footer
      >
        <!-- Start:: Serial Number -->
        <template v-slot:[`item.id`]="{ index }">
          {{ (paginations.current_page - 1) * paginations.items_per_page + index + 1 }}
        </template>
        <!-- End:: Serial Number -->

        <!-- Start:: No Data State -->
        <template v-slot:no-data>
          {{ $t("TABLES.noData") }}
        </template>
        <!-- End:: No Data State -->

        <!-- Start:: Order Number (Clickable) -->
        <template v-slot:[`item.order_id`]="{ item }">
          <button 
            class="text-primary text-decoration-underline border-0 bg-transparent"
            @click="navigateToOrder(item)"
          >
            {{ item.order_id }}
          </button>
        </template>
        <!-- End:: Order Number -->
      </v-data-table>
      <!--  =========== End:: Data Table =========== -->

      <!-- ==== Start:: Overall Statistics ==== -->
      <div class="table_content" v-if="totals">
        <v-simple-table class="stat-table">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-center">
                  {{ $t("FINANCIAL_REPORTS.total_orders") }}
                </th>
                <th class="text-center">
                  {{ $t("FINANCIAL_REPORTS.total_provider_amount") }}
                </th>
                <th class="text-center">
                  {{ $t("FINANCIAL_REPORTS.total_commission") }}
                </th>
                <th class="text-center">
                  {{ $t("FINANCIAL_REPORTS.total_tax") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="text-center all-stat">
                <td>{{ totals.total_orders || 0 }}</td>
                <td>{{ totals.total_provider_amount || 0 }}</td>
                <td>{{ totals.total_commission || 0 }}</td>
                <td>{{ totals.total_tax || 0 }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
      <!-- ==== End:: Overall Statistics ==== -->
    </main>
    <!-- End:: Main Section -->

    <!-- Start:: Pagination -->
    <!-- <template>
      <div class="pagination_container text-center mt-3 mb-0">
        <v-pagination class="py-0" square v-model="paginations.current_page" :length="paginations.last_page"
          :total-visible="6" @input="updateRouterQueryParam($event)" :prev-icon="getAppLocale == 'ar' ? 'fal fa-angle-right' : 'fal fa-angle-left'
            " :next-icon="getAppLocale == 'ar' ? 'fal fa-angle-left' : 'fal fa-angle-right'
              " />
      </div>
    </template> -->
    <!-- End:: Pagination -->

    <!-- Start:: Generate PDF Template Content -->
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="true"
      :filename="$t('PLACEHOLDERS.FinancialOrders')"
      :pdf-quality="2"
      pdf-format="a4"
      :manual-pagination="false"
      :paginate-elements-by-height="1400"
      pdf-content-width="100%"
      @progress="pdfDownloadBtnIsLoading = true"
      @hasGenerated="pdfDownloadBtnIsLoading = false; $message.success($t('PLACEHOLDERS.FinancialOrders'))"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div class="pdf_file_content">
          <h3 class="file_title">{{ $t("PLACEHOLDERS.FinancialOrders") }}</h3>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th v-for="header in tableHeaders" :key="header.value">
                    <span>{{ header.text }}</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in tableRows" :key="row.order_id">
                  <td>{{ index + 1 }}</td>
                  <td>{{ row.user_name || "-" }}</td>
                  <td>{{ row.provider_name || "-" }}</td>
                  <td>{{ row.order_id || "-" }}</td>
                  <td>{{ row.created_at || "-" }}</td>
                  <td>{{ row.provider_amount || "-" }}</td>
                  <td>{{ row.commission || "-" }}</td>
                  <td>{{ row.tax || "-" }}</td>
                  <td>{{ row.delivery_price || "-" }}</td>
                </tr>
                <tr v-if="totals" class="totals-row">
                  <td colspan="5" style="text-align: center; font-weight: bold;">{{ $t("FINANCIAL_REPORTS.totals") }}</td>
                  <td style="font-weight: bold;">{{ totals.total_provider_amount || 0 }}</td>
                  <td style="font-weight: bold;">{{ totals.total_commission || 0 }}</td>
                  <td style="font-weight: bold;">{{ totals.total_tax || 0 }}</td>
                  <td style="font-weight: bold;">-</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </section>
    </vue-html2pdf>
    <!-- End:: Generate PDF Template Content -->
  </div>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf";
import { mapGetters } from "vuex";

export default {
  name: "AllFinancialReports",

  components: {
    VueHtml2pdf,
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
  },

  data() {
    return {
      // Start:: Loading Data
      loading: false,
      isWaitingRequest: false,
      pdfDownloadBtnIsLoading: false,
      // End:: Loading Data

      // Start:: Filter Data
      filterFormIsActive: false,
      filterOptions: {
        order_id: null,
        user_name: null,
        provider_name: null,
        created_at_from: null,
        created_at_to: null,
      },
      // End:: Filter Data

      // Start:: Table Data
      searchValue: "",
      tableHeaders: [
        {
          text: this.$t("TABLES.Admins.serialNumber"),
          value: "id",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("FINANCIAL_REPORTS.user_name"),
          value: "user_name",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("FINANCIAL_REPORTS.provider_name"),
          value: "provider_name",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.order_number"),
          value: "order_id",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("PLACEHOLDERS.order_date"),
          value: "created_at",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("FINANCIAL_REPORTS.provider_amount"),
          value: "provider_amount",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("FINANCIAL_REPORTS.commission"),
          value: "commission",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("FINANCIAL_REPORTS.tax"),
          value: "tax",
          sortable: false,
          align: "center",
        },
        // {
        //   text: this.$t("FINANCIAL_REPORTS.net_profit"),
        //   value: "delivery_price",
        //   sortable: false,
        //   align: "center",
        // },
      ],
      tableRows: [],
      totals: null,
      excel_export_url: null,
      // End:: Table Data

      // Start:: Pagination Data
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 15,
      },
      // End:: Pagination Data
    };
  },

  watch: {
    // Start:: Page Query Param Watcher To Get Page Data Based On It's Change
    ["$route.query.page"]() {
      this.paginations.current_page = +this.$route.query.page;
      this.setTableRows();
    },
    // End:: Page Query Param Watcher To Get Page Data Based On It's Change
  },

  methods: {
    // Start:: Handel Filter
    async submitFilterForm() {
      if (this.$route.query.page !== "1") {
        await this.$router.push({
          path: "/financialorders/all",
          query: { page: 1 },
        });
      }
      this.setTableRows();
    },
    async resetFilter() {
      this.filterOptions.order_id = null;
      this.filterOptions.user_name = null;
      this.filterOptions.provider_name = null;
      this.filterOptions.created_at_from = null;
      this.filterOptions.created_at_to = null;
      
      if (this.$route.query.page !== "1") {
        await this.$router.push({
          path: "/financialorders/all",
          query: { page: 1 },
        });
      }
      this.setTableRows();
    },
    // End:: Handel Filter

    // Start:: Set Table Rows
    updateRouterQueryParam(pagenationValue) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: pagenationValue,
        },
      });

      // Scroll To Screen's Top After Get Orders
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },
    
    async setTableRows() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: "orders/reports",
          params: {
            page: this.paginations.current_page,
            id: this.filterOptions.order_id,
            user_name: this.filterOptions.user_name,
            provider_name: this.filterOptions.provider_name,
            created_at_from: this.filterOptions.created_at_from,
            created_at_to: this.filterOptions.created_at_to,
          },
        });
        this.loading = false;
        this.tableRows = res.data.data.data;
        this.totals = res.data.data.totals;
        this.excel_export_url = res.data.data.export_url;
        this.paginations.last_page = res.data.data.last_page || 1;
        this.paginations.items_per_page = res.data.data.per_page || 15;
      } catch (error) {
        this.loading = false;
        console.log(error.response?.data?.message);
      }
    },
    // End:: Set Table Rows

    // Start:: Navigate To Order
    navigateToOrder(item) {
      // Determine route based on order type
      const orderTypeRoutes = {
        'horse_purchase': '/horse-purchase/show/',
        'horse_rent': '/horse-rent/show/',
        'room_rent': '/room-rent/show/',
        'carrier_service': '/carrier-service/show/',
        'products': '/product-orders/show/',
        'other_service': '/other-service/show/',
      };
      
      const route = orderTypeRoutes[item.order_type] || '/orders/show/';
      this.$router.push({ path: `${route}${item.order_id}` });
    },
    // End:: Navigate To Order

    // Start:: Handling Download Files
    async downloadPdf() {
      try {
        const params = {
          export_as: 'pdf',
          page: this.paginations.current_page,
        };
        if (this.filterOptions.order_id) {
          params.id = this.filterOptions.order_id;
        }
        if (this.filterOptions.user_name) {
          params.user_name = this.filterOptions.user_name;
        }
        if (this.filterOptions.provider_name) {
          params.provider_name = this.filterOptions.provider_name;
        }
        if (this.filterOptions.created_at_from) {
          params.created_at_from = this.filterOptions.created_at_from;
        }
        if (this.filterOptions.created_at_to) {
          params.created_at_to = this.filterOptions.created_at_to;
        }

        const response = await this.$axios({
          method: 'GET',
          url: 'orders/reports',
          params: params,
          responseType: 'blob',
        });

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'financial-report.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      } catch (error) {
        console.log(error);
        this.$message.error(this.$t("MESSAGES.downloadFailed"));
      }
    },

    async downloadExcel() {
      try {
        const params = {
          export_as: 'excel',
          page: this.paginations.current_page,
        };
        if (this.filterOptions.order_id) {
          params.id = this.filterOptions.order_id;
        }
        if (this.filterOptions.user_name) {
          params.user_name = this.filterOptions.user_name;
        }
        if (this.filterOptions.provider_name) {
          params.provider_name = this.filterOptions.provider_name;
        }
        if (this.filterOptions.created_at_from) {
          params.created_at_from = this.filterOptions.created_at_from;
        }
        if (this.filterOptions.created_at_to) {
          params.created_at_to = this.filterOptions.created_at_to;
        }

        const response = await this.$axios({
          method: 'GET',
          url: 'orders/reports',
          params: params,
          responseType: 'blob',
        });

        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'financial-report.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      } catch (error) {
        console.log(error);
        this.$message.error(this.$t("MESSAGES.downloadFailed"));
      }
    },
    // End:: Handling Download Files
  },

  created() {
    // Start:: Fire Methods
    window.addEventListener("click", () => {
      this.filterFormIsActive = false;
    });
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setTableRows();
    // End:: Fire Methods
  },
};
</script>

<style scoped>
.ex-btn-s {
  color: black !important;
  font-size: 20px;
  font-weight: bold;
  text-decoration: underline !important;
}

.all-stat {
  background: var(--main_theme_clr);
}

.all-stat td {
  color: white;
  font-size: 21px !important;
  font-weight: 800;
}

.show_all_content_wrapper
  .v-data-table
  .v-data-table__wrapper
  table
  tbody
  tr:hover {
  background: var(--main_theme_clr) !important;
}

.excel {
  background: darkgreen;
  padding: 7px 10px;
  border-radius: 12px;
  color: #fff;
  cursor: pointer;
}
</style>
